import Vue from 'vue'

Vue.filter('rTime', (date) => {
  if (!date) return ''
  const str = date.replace(/-/g, '/').replace('T', ' ').split('.')[0]
  const dt = new Date(str)
  const y = dt.getFullYear()
  const m = (dt.getMonth() + 1).toString().padStart(2, '0')
  const d = dt.getDate().toString().padStart(2, '0')
  const h = dt.getHours().toString().padStart(2, '0')
  const mm = dt.getMinutes().toString().padStart(2, '0')
  const s = dt.getSeconds().toString().padStart(2, '0')
  return `${y}-${m}-${d} ${h}:${mm}:${s}`
  // const jsonDate = new Date(date).toJSON()
  // return new Date(new Date(jsonDate) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
})

Vue.filter('rTime1', (date) => {
  if (!date) return ''
  const str = date.replace(/-/g, '/').replace('T', ' ').split('.')[0]
  const dt = new Date(str)
  const y = dt.getFullYear()
  const m = (dt.getMonth() + 1).toString().padStart(2, '0')
  const d = dt.getDate().toString().padStart(2, '0')
  const h = dt.getHours().toString().padStart(2, '0')
  const mm = dt.getMinutes().toString().padStart(2, '0')
  const s = dt.getSeconds().toString().padStart(2, '0')
  return `${y}-${m}-${d}`
  // const jsonDate = new Date(date).toJSON()
  // return new Date(new Date(jsonDate) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
})

Vue.filter('amount', (number) => {
  if (!number) return '0.00'
  return parseFloat(number / 100).toFixed(2)
})

Vue.filter('regDecimalPoint', (number) => {
  if (!number) return '0.00';
  number = parseFloat(parseFloat(number).toFixed(8));
  number += '';
  if (number.indexOf(".") > -1) {
    let len = number.split(".")[1].length;
    if (len === 1) {
      return parseFloat(number).toFixed(2)
    } else {
      return number
    }
  } else {
    return parseFloat(number).toFixed(2)
  }
})

Vue.filter('tableNone', (value) => {
  if (!value && value !== 0) return '-'
  return value
})



// WEBPACK FOOTER //
// ./src/utils/globalVueConfig.js